// The web font stylesheet loads without blocking render (see index.html), so a font lookup made
// before it arrives finds nothing. Waits for the sheet, then loads the given faces.
let sheet: Promise<void> | undefined;

function sheetLoaded(): Promise<void> {
  return (sheet ??= new Promise(done => {
    const link = document.querySelector<HTMLLinkElement>('link[data-fonts]');
    if (!link || link.media === 'all') return done();
    link.addEventListener('load', () => done(), { once: true });
    link.addEventListener('error', () => done(), { once: true });
  }));
}

export function fontsReady(faces: string[]): Promise<unknown> {
  return sheetLoaded().then(() => Promise.all(faces.map(f => document.fonts?.load(f))));
}
